import api, { normalizeList } from './api';

// Maintain backward compatibility with existing imports
export const getWorkflowConfig = () => api.get('/api/service-orders/workflow-configs/');
export const getWorkflowStates = () => api.get('/api/service-orders/workflow-states/');
export const getWorkflowTransitions = () => api.get('/api/service-orders/workflow-transitions/');

// New functions that handle paginated responses
export const getWorkflowStatesList = async () => {
    try {
        const response = await api.get('/api/service-orders/workflow-states/');
        return normalizeList(response.data);
    } catch (error) {
        console.error('Error fetching workflow states:', error);
        return [];
    }
};

export const getWorkflowTransitionsList = async () => {
    try {
        const response = await api.get('/api/service-orders/workflow-transitions/');
        return normalizeList(response.data);
    } catch (error) {
        console.error('Error fetching workflow transitions:', error);
        return [];
    }
};
export const createWorkflowState = (data) => api.post('/api/service-orders/workflow-states/', data);
export const updateWorkflowState = (id, data) => api.put(`/api/service-orders/workflow-states/${id}/`, data);
export const deleteWorkflowState = (id) => api.delete(`/api/service-orders/workflow-states/${id}/`);
export const createWorkflowTransition = (data) => api.post('/api/service-orders/workflow-transitions/', data);
export const updateWorkflowTransition = (id, data) => api.put(`/api/service-orders/workflow-transitions/${id}/`, data);
export const deleteWorkflowTransition = (id) => api.delete(`/api/service-orders/workflow-transitions/${id}/`);
export const updateWorkflowConfig = (id, data) => api.put(`/api/service-orders/workflow-configs/${id}/`, data);

// Get available workflow states for a specific workflow config
export const getAvailableWorkflowStates = (workflowConfigId) => 
    api.get(`/api/service-orders/workflow-configs/${workflowConfigId}/available_states/`);

// Get workflow states that allow invoice upload (configurable)
export const getInvoiceUploadAllowedStates = () => 
    api.get('/api/service-orders/workflow-configs/invoice-upload-allowed-states/');

// Also export as a service object for new code
export const workflowService = {
    getWorkflowConfig,
    getWorkflowStates,
    getWorkflowTransitions,
    createWorkflowState,
    updateWorkflowState,
    deleteWorkflowState,
    createWorkflowTransition,
    updateWorkflowTransition,
    deleteWorkflowTransition,
    updateWorkflowConfig,
    getAvailableWorkflowStates,
    getInvoiceUploadAllowedStates,
}; 